import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import logo from '../assets/images/logo.png'

import PlainButton from "./PlainButton"
import BorderButton from './BorderButton';

const Navbar = () => {
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 333 });
  const [titleSize, setTitleSize] = useState('fs-1');
  
  useEffect(() => {
    if (isMobile) {
      setTitleSize('fs-3')
    } else {
      setTitleSize('fs-1')
    }
  }, [isMobile])
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>

      <div className='border-0 bg-main'>
        <img src={logo} style={{ width: '100%', margin: '0', padding: '0', opacity: '0.75' }} alt="Art Alive Logo" />
      </div>

      <div className='px-1 bg-main d-flex justify-content-center align-items-center'>
        <Link className={`navbar-brand text-center`} to="/">
          <h1 className={`${titleSize} text-dark-main font-custom`}>Art Alive Art School</h1>
        </Link>
      </div>
      
      <nav className={`w-100 p-3 navbar navbar-expand-lg bg-main`}>
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`p-2 collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav mx-auto gap-2">
              <BorderButton url='/' button_border='bright-accent' button_text='dark-main'>Home</BorderButton>
              <BorderButton url='/about' button_border='bright-accent' button_text='dark-main'>About</BorderButton>
              <BorderButton url='/classes' button_border='bright-accent' button_text='dark-main'>Classes</BorderButton>
              <BorderButton url='/teachers' button_border='bright-accent' button_text='dark-main'>Teachers</BorderButton>
              <BorderButton url='/events' button_border='bright-accent' button_text='dark-main'>Events</BorderButton>
              <PlainButton url='/contact' button-border='' button_color='bright-accent' button_text='dark-main'>Join</PlainButton>
              <PlainButton url='/contact' button-border='' button_color='bright-accent' button_text='dark-main'>Contact Us</PlainButton>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );

}

export default Navbar;